/**
 * Shared dispatch tab rules (keep in sync with DispatchScreen tab filters).
 */

/**
 * Assign Driver tab: pending or requested, store order placed, driver pay set,
 * and no driver on the resolved parent order (main order or add-on parent).
 *
 * @param {object} order
 * @param {object[]} allOrders - Full list for originalOrderId → parent lookup
 */
export function isAssignDriverOrder(order, allOrders = []) {
  if (order.status !== 'pending' && order.status !== 'requested') return false;

  const spend = parseFloat(order.storeSpend);
  if (isNaN(spend) || spend <= 0) return false;

  const pay = parseFloat(order.driverPay);
  if (isNaN(pay) || pay <= 0) return false;

  if (!order.storeOrderId?.trim()) return false;

  const parent = order.originalOrderId
    ? allOrders.find((p) => String(p._id) === String(order.originalOrderId))
    : null;
  const resolved = parent || order;
  return !resolved.driverID;
}
